import Modal from "../Modal";
import { useGetDoublesMatchesQuery } from "../../api/completeMatchesSlice";
import DoublesMatchesList from "./DoublesMatchesList";
import Spinner from "../../../UI/Spinner";
import { useEffect, useState } from "react";
import {
  setSelectedMatches,
  setMatches,
  selectMatches,
  selectSelectedMatches
} from "../store/matchesSlice";
import { useDispatch, useSelector } from "react-redux";
import classes from "./DoublesMatchesList.module.css";

const DoublesMatches = () => {
  const dispatch = useDispatch();
  const selectedMatches = useSelector(selectSelectedMatches);
  const matches = useSelector(selectMatches);
  const [currentFiltersSnapshot, setCurrentFiltersSnapshot] = useState({
    matches,
    selectedMatches
  });

  const { data: filteredMatches, isLoading: loadingDoublesMatches } = useGetDoublesMatchesQuery();

  useEffect(() => {
    if (filteredMatches && !currentFiltersSnapshot.matches) {
      let newMatches = filteredMatches.matches.map((m) => ({
        ...m,
        isSelected: currentFiltersSnapshot.selectedMatches.some((sm) => sm.matchId === m.matchId),
      }));
      setCurrentFiltersSnapshot((prevState) => ({
        ...prevState,
        matches: newMatches,
      }));
    }
  }, [filteredMatches]);

  const matchesMultipleSelection = (targetSelectionValue) => {
    setCurrentFiltersSnapshot((prevState) => {
      const newMatches = prevState.matches.map((m) => ({
        ...m,
        isSelected: targetSelectionValue,
      }));

      let newSelectedMatches = [];
      if (targetSelectionValue) {
        const matchesAddedToSelection = newMatches.filter(
          (m) => !prevState.selectedMatches.some((selected) => selected.matchId === m.matchId)
        );
        newSelectedMatches = [...prevState.selectedMatches, ...matchesAddedToSelection];
      } else {
        newSelectedMatches = prevState.selectedMatches.filter(
          (selected) => !newMatches.some((m) => m.matchId === selected.matchId)
        );
      }

      return {
        ...prevState,
        matches: newMatches,
        selectedMatches: newSelectedMatches,
      };
    });
  };

  const ApplySnapshotHandler = () => {
    if (filteredMatches.matches.length === 0) currentFiltersSnapshot.selectedMatches = [];

    dispatch(setMatches(currentFiltersSnapshot.matches));
    dispatch(setSelectedMatches(currentFiltersSnapshot.selectedMatches));
  };

  const MatchSelectionToggleHandler = (match) => {
    const newMatch = { ...match };
    newMatch.isSelected = !newMatch.isSelected;
  
    setCurrentFiltersSnapshot((prevState) => {
      // Handle case where prevState.matches is null
      const newMatches = prevState.matches 
        ? prevState.matches.map((m) => (m.matchId === newMatch.matchId ? newMatch : m))
        : [newMatch]; // If matches were null, initialize with just this match
      
      let newSelectedMatches = [];
      if (newMatch.isSelected) {
        newSelectedMatches = [...(prevState.selectedMatches || []), newMatch];
      } else {
        newSelectedMatches = (prevState.selectedMatches || []).filter((m) => m.matchId !== newMatch.matchId);
      }
  
      return {
        ...prevState,
        matches: newMatches,
        selectedMatches: newSelectedMatches,
      };
    });
  };

  const selectMatchesClicked = () => {
    setCurrentFiltersSnapshot({
      matches,
      selectedMatches
    });
  };

  if (loadingDoublesMatches)
    return (
      <div style={{ height: "3rem" }} className="card mb-3 row justify-content-center ml-1 mr-1">
        <Spinner />
      </div>
    );
  else if (filteredMatches)
    return (
      <div className={`card mb-3 ml-1 mr-1 ${classes["matches-card"]}`}>
        <div className="d-flex flex-wrap p-1 align-items-center">
          <div className="mr-auto">
            <button
              style={{ width: "fit-content", height: "fit-content" }}
              className="btn btn-light ml-1 mb-1"
              type="button"
              data-toggle="modal"
              data-target="#matchesFilterModal"
              onClick={selectMatchesClicked}
            >
              Select Matches ({selectedMatches.length}) <i className="fas fa-filter"></i>
            </button>
          </div>
        </div>
        <Modal onApplyFilter={ApplySnapshotHandler} countSelected={currentFiltersSnapshot.selectedMatches.length}>
        {loadingDoublesMatches ? (
            <Spinner />
            ) : filteredMatches && filteredMatches.matches.length > 0 ? (
            <DoublesMatchesList
                matches={currentFiltersSnapshot.matches || filteredMatches.matches.map(m => ({
                ...m,
                isSelected: currentFiltersSnapshot.selectedMatches.some(sm => sm.matchId === m.matchId)
                }))}
                onToggleMatch={MatchSelectionToggleHandler}
                matchesMultipleSelection={matchesMultipleSelection}
            />
            ) : (
            <div className="d-flex justify-content-center">
                <h4>Please select a player.</h4>
            </div>
            )}
          {currentFiltersSnapshot && currentFiltersSnapshot.selectedMatches.length > 0 && <hr />}
          {currentFiltersSnapshot && currentFiltersSnapshot.selectedMatches.length > 0 && (
            <div className={`d-flex justify-content-center ${classes["table-container"]}`}>
              <table
                className={`table table-sm table-dark table-responsive scrollbar perfect-scrollbar ${classes["matches-table"]}`}
              >
                <caption>Selected Matches</caption>
                <thead>
                  <tr>
                    <th scope="col">
                      <input
                        type="checkbox"
                        readOnly
                        checked={true}
                        onClick={() =>
                          setCurrentFiltersSnapshot((prevState) => ({
                            ...prevState,
                            selectedMatches: [],
                            matches: prevState.matches.map((m) => ({ ...m, isSelected: false })),
                          }))
                        }
                      />
                    </th>
                    <th scope="col" className="text-nowrap">
                      First Team
                    </th>
                    <th scope="col" className="text-nowrap">
                      Second Team
                    </th>
                    <th scope="col" className="text-nowrap">
                      Event
                    </th>
                    <th scope="col" className="text-nowrap">
                      Round
                    </th>
                    <th scope="col" className="text-nowrap">
                      Surface
                    </th>
                    <th scope="col" className="text-nowrap">
                      Winner
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {currentFiltersSnapshot.selectedMatches.map((match) => (
                    <tr key={match.matchId}>
                      <th scope="row">
                        <input
                          type="checkbox"
                          checked={match.isSelected}
                          onChange={() => MatchSelectionToggleHandler(match)}
                        />
                      </th>
                      <td className="text-nowrap">{match.firstTeamName}</td>
                      <td className="text-nowrap">{match.secondTeamName}</td>
                      <td className="text-nowrap">{match.eventName}</td>
                      <td className="text-nowrap">{match.roundName}</td>
                      <td className="text-nowrap">{match.surface}</td>
                      <td className="text-nowrap">{match.winnerName}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </Modal>
      </div>
    );
  else
    return (
      <div style={{ height: "3rem" }} className="card mb-3 row justify-content-center ml-1 mr-1">
        <div className="align-items-center justify-content-center">
          <h4>
            {" "}
            {status} {error.status} {JSON.stringify(error.error)}
          </h4>
        </div>
      </div>
    );
};

export default DoublesMatches;
